import React, { Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  cancelConfiguration, setActiveStep, preSaveConfiguration, addSoftwareLicences, removeSoftwareLicence, setSoftwareLicenceQuantity,
  setLicenseModel,
  updateMsxSoftwareLicenseReferences,
} from '../../configuration-management/ducks';
import { openModal, closeModal } from '../../modals/ducks';
import { stepsConfig, configurationStatuses, softwareStepsConfig, SUBSTITUTION_TYPE_REPLACE } from '../../../constants';
import { getSoftwareStepperLabels } from '../../../utils/linear-stepper';
import I10n from '../../../features/i10n';
import Configuration from '../../../models/Configuration';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration } from '../../../utils/app-starter';
import ApplicationFullHeader from '../../../components/application_full_header';
import Scrollbars from 'react-custom-scrollbars';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import Button from '../../../atoms/button';
import { getLicenceCategories } from './ducks';
import Skeleton from '../../../components/skeleton';
import LicenceGroup from '../../../components/software_licence/licenceGroup';
import { showNotificationWithButton } from '../../notification/ducks';
import LicenceSelectorHMCToggle from '../../../components/software_licence/licence_selector_hmc_toggle';
import MsxIcons from '../../msx-icons';
import { resetCBRSelectedItems, setCBRSelectedItems } from '../../call-by-range/ducks';
import { logDeleteCBRFilterEvent } from '../../../utils/analytics-logger';
import Notification from '../../notification';
import { SECONDARY_COLOR } from '../../../color-constants';

const HELP_ME_CHOOSE = 'help_me_choose';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
  min-height: calc(100vh - 2em);
  overflow-x: hidden;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
`;

const ScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 16px 0px 16px;
  ${props => props.fullScreenEnabled && `
  `}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding-top: 20px;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  margin-bottom: 50px;
  @media (max-width: 800px) {
    margin-bottom: 40px;
  }
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  z-index: 30;
  background-color: white;
  border-top: 2px solid #EDEDED;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const HelpMeChooseWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 0px;
  transform: translateY(-100%);
`;

// To be removed
const NotificationContainer = styled.div`
  position: fixed;
  top: 150px;
  left: 16px;
  right: 16px;
  z-index: 400;
  white-space: pre-line;
`;

const NotificationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background-color: ${SECONDARY_COLOR};
  background-color: var(--se-primary, ${SECONDARY_COLOR});
  color: white !important;
  color: var(--se-primary-contrast, white) !important;
`;

const IconWrapper = styled.div`
  cursor: pointer;
  height: 20px;
  width: 20px;
  margin-left: 10px;
`;

const CheckAndMessageWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const CheckIconWrapper = styled.div`
  margin-right: 10px;
`;

const OutdatedLicenseModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OutdatedLicenseModalLabel = styled.span`
  margin-bottom: 10px;
`;

const OutdatedLicenseModalRowLabel = styled.span`
  margin-bottom: 5px;
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

class LicenceSelectorScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isDesktop: window.innerWidth > 800,
      licenceGroups: [],
      scopedLicences: {},
      availableLicenseModel: [],
      licencesLoading: false,
      showNotification: false,  // To be removed
      notificationText: null // To be removed
    };
    this._isMounted = false;
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  loadLicenseCategories = (isMountCall) => {

    this.updateStateIfMounted({licencesLoading: true});
    getLicenceCategories(this.props.configuration.softwareSelection, this.props.configuration.licenseModel).then((licenceGroups) => {
      const allLicences = [];
      const scopedLicences = {};
      const availableLicenseModel = {};
      for (const licenceGroup of (licenceGroups || [])) {
        for (const licenceType of (licenceGroup.licenceTypes || [])) {
          allLicences.push(...(licenceType.references || []));
          (licenceType.scopedReferences || []).forEach(l => {
            scopedLicences[l.id] = true;
          });
          (licenceType.allScopedReferences || []).forEach(l => {
            availableLicenseModel[l.licenseModel] = true;
          });
        }
      }

      const scopedLicenseModels = (this.props.configuration.softwareInfo?.availableLicenseModels || []).filter(licenseModel => {
        return availableLicenseModel[licenseModel.applicationValue];
      });

      this.updateStateIfMounted({licenceGroups, scopedLicences, availableLicenseModel: scopedLicenseModels});

      if (isMountCall) {
        // Add automatically licences from the call by range
        const cbrReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];
        const referencesToAdd = cbrReferences.filter(value => allLicences.includes(value));

        if (referencesToAdd.length > 0) {
          this.addSoftwareLicences(referencesToAdd.map((licence) => { return {id: licence, quantity: 1};}), 'auto');
        }
      }
    }).finally(() => {
      this.updateStateIfMounted({licencesLoading: false});
    });
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateIsDesktop);
    this._isMounted = true;
    this.loadLicenseCategories(true);
    if (this.props.configuration.status === configurationStatuses.finished && (this.props.configuration.outdatedLicenses || []).length > 0) {
      // Ask for license migration
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
            this.props.setActiveStep(stepsConfig.save_screen);
          },
          onSubmit: () => {
            this.props.closeModal();
            this.props.updateMsxSoftwareLicenseReferences(this.props.configuration);
          },
          title: I10n.get('screen.licence_selector.outdated_licences.modal.title'),
          text: this.buildOutdatedLicensesModalContent(),
          cancelText: I10n.get('app.action.no'),
          submitText: I10n.get('app.action.yes')
        }
      });
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
    this._isMounted = false;
    this.props.closeModal();
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  buildOutdatedLicensesModalContent = () => {
    return (<OutdatedLicenseModalContentWrapper>
      <OutdatedLicenseModalLabel>
        {I10n.get('screen.licence_selector.outdated_licences.modal.body')}
      </OutdatedLicenseModalLabel>
      {this.props.configuration.outdatedLicenses.map((outdatedItem, idx) => {
        if (outdatedItem.outdatedType === SUBSTITUTION_TYPE_REPLACE) {
          return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplaceMultiple('screen.licence_selector.outdated_licences.modal.updated', [outdatedItem.oldLicense, outdatedItem.newLicense])}</OutdatedLicenseModalRowLabel>;
        }
        return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplace('screen.licence_selector.outdated_licences.modal.removed', outdatedItem.oldLicense)}</OutdatedLicenseModalRowLabel>;
      })}
    </OutdatedLicenseModalContentWrapper>);
  }

  showDuplicateConfirmationModal = (callback) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    if (isSaved && !this.props.configuration.allowSavedModifications) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get('modal.change_saved_configuration.title'),
          text: I10n.get('modal.change_saved_configuration.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      callback();
    }
  }

  removeSoftwareLicence = (licence, cancelCallback) => {
    this.showDuplicateConfirmationModal(() => {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { if (cancelCallback) { cancelCallback(); } this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            this.props.removeSoftwareLicence(licence);
          },
          title: I10n.get('screen.licence_selector.remove_licence.modal.title'),
          text: I10n.get('screen.licence_selector.remove_licence.modal.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    });
  }

  renderMainSection = () => {
    return (
      <ContentWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        {this.state.licencesLoading ? (<Skeleton nbCols={2} expand={true}></Skeleton>
        ) :
        <>
          {(this.state.licenceGroups.map((group, idx) => {
            return <Fragment key={idx}>
                <LicenceGroup
                  licenceGroup={group}
                  isSaving={this.props.configurationSaver.isSaving}
                  onAddSoftwareLicencesRequested={this.onAddSoftwareLicencesRequested}
                  softwareLicences={this.props.configuration.softwareLicences}
                  configurationSaver={this.props.configurationSaver}
                  removeSoftwareLicence={this.removeSoftwareLicence}
                  setSoftwareLicenceQuantity={this.props.setSoftwareLicenceQuantity}
                  licenseLevel={this.computeLicenseLevel()}
                  licenseModel={this.props.configuration.licenseModel}
                />
            </Fragment>
          }))}
        </>
        }
      </ContentWrapper >
    );
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  hasActiveCBRFilters = () => {
    return (this.props.callByRangeReducer?.selectedItems?.references && Object.keys(this.props.callByRangeReducer?.selectedItems?.references).length > 0) ||
      (this.props.callByRangeReducer?.selectedItems?.ranges && Object.keys(this.props.callByRangeReducer?.selectedItems?.ranges).length > 0);
  }

  getStepperActions = (isSaved) => {
    const config = new Configuration(this.props.configuration);

    return [
      { action: () => {
        if (this.hasActiveCBRFilters()) {
          this.props.openModal({
            modalType: 'confirmation',
            modalProps: {
              onCancel: () => { this.props.closeModal(); },
              onSubmit: () => {
                this.props.resetCallByRangeSelectedItems();
                this.props.closeModal();
                if (configurationStatuses.finished === config.status) {
                  this.props.setActiveStep(softwareStepsConfig.software_selection);
                } else {
                  this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.software_selection).then(() => {
                  }).catch(() => { });
                }
              },
              title: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.title'),
              text: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.body'),
              cancelText: I10n.get('app.action.no'),
              submitText: I10n.get('app.action.yes'),
            }
          });
        } else {
          if (configurationStatuses.finished === config.status) {
            this.props.setActiveStep(softwareStepsConfig.software_selection);
          } else {
            this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.software_selection).then(() => {
            }).catch(() => { });
          }
        }
      }, active: true, done: true },
      { action: () => {}, active: false, done: isSaved },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(softwareStepsConfig.service_plan);
          } else {
            this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.service_plan).then(() => {
            }).catch(() => { });
          }
        },
        active: this.props.configuration.softwareLicences?.length > 0, done: isSaved,
        hidden: this.props.configuration.servicePlanItems?.length === 0
      },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(stepsConfig.save_screen);
          } else {
            this.props.saveConfiguration(this.props.configuration).then(() => {
              this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
            }).catch(() => { });
            this.props.closeModal();
          }
        }, active: this.props.configuration.softwareLicences?.length > 0 , done: isSaved
      },
    ];
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };

  clearCBRCategory = (category) => {
    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { this.props.closeModal(); },
        onSubmit: () => {
          const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
          if (newValue.selectedItems[category]) {
            newValue.selectedItems[category] = {};
          }
          this.props.setCallByRangeSelectedItems(newValue);
          logDeleteCBRFilterEvent(this.props.configuration?.id, softwareStepsConfig.licence_selector, category);
          this.props.closeModal();
        },
        title: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.title'),
        text: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.body'),
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.apply'),
      }
    });
  }

  renderScreenContent = () => {
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          <MainContentWrapper ref={this.setWrapperRef}>
            {this.renderMainSection()}
          </MainContentWrapper>
          <Notification>
          </Notification>
        </ScreenContent>
      </>
    );
  }

  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> : <Scrollbars>
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    </Scrollbars>);
  }

  computeLicenseLevel = () => {
    let result;

    for (let i = 0; i < (this.props.configuration?.softwareLicences || []).length && result == null ; i++) {
      const softwareLicence = this.props.configuration?.softwareLicences[i];
      if (softwareLicence.licenseLevel != null) {
        result = softwareLicence.licenseLevel;
      }
    }

    return result;
  }

  openSelectorModal = (licenceType, scopedLicences, onSubmitCallback) => {
    this.props.openModal({
      modalType: 'software-licence-selector',
      modalProps: {
        softwareLicences: this.props.configuration.softwareLicences,
        softwareSelection: this.props.configuration.softwareSelection,
        scopedLicences: scopedLicences,
        availableLicenseModel: this.state.availableLicenseModel,
        licenceType,
        licenseModel: this.props.configuration.licenseModel,
        licenseLevel: this.computeLicenseLevel(),
        onSubmit: (licencesToAdd) => {
          onSubmitCallback(licencesToAdd);
          this.props.closeModal();
        }
      }
    });
  }

  addSoftwareLicences = (licencesToAdd, selectorOrigin) => {
    this.props.addSoftwareLicences(licencesToAdd, selectorOrigin).then(() => {
      if (licencesToAdd.length >= 1) {
        this.showNotification(I10n.get('screen.licence_selector.notification.licences_added'), 'success', null);
      }
    });
  }

  onAddSoftwareLicencesRequested = (licenceType) => {
    this.showDuplicateConfirmationModal(() => {
      const licencesToAdd = [];
      const scopedLicences = {};
      (licenceType.scopedReferences || []).forEach(licence => {
        scopedLicences[licence.id] = true;
        licencesToAdd.push({
          id: licence.id,
          quantity: 1
        });
      });
      if (licenceType.openSelector) {
        this.openSelectorModal(licenceType.key, scopedLicences, (licences) => {
          this.addSoftwareLicences(licences, licenceType.key);
        });
      } else {
        this.addSoftwareLicences(licencesToAdd, licenceType.key);
      }
    });
  }

  openHelpMeChooseModal = () => {
    this.openSelectorModal(HELP_ME_CHOOSE, this.state.scopedLicences, (licencesToAdd) => {
      this.addSoftwareLicences(licencesToAdd, HELP_ME_CHOOSE);
    });
  }

  renderNavigationButtonSection = () => {
    const buttons = <>
      <CancelWrapper>
        <Button
          id='license-selector-screen-back-button'
          disabled={this.props.configurationSaver.isSaving}
          onClick={event => {
            this.props.setActiveStep(softwareStepsConfig.software_selection);
          }}
        >
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      <Button
        importance="emphasized"
        primary
        disabled={this.props.configurationSaver.isSaving || this.props.configuration.softwareLicences?.length === 0 }
        onClick={event => {
          if (this.props.configuration.servicePlanItems?.length > 0) {
            if (configurationStatuses.finished === this.props.configuration.status) {
              this.props.setActiveStep(softwareStepsConfig.service_plan);
            } else {
              this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.service_plan)
                .then(() => {})
                .catch(() => {});
              this.props.closeModal();
            }

          } else {
            if (configurationStatuses.finished === this.props.configuration.status) {
              this.props.setActiveStep(stepsConfig.save_screen);
            } else {
              this.props.saveConfiguration(this.props.configuration, softwareStepsConfig.service_plan).then(() => {
                this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
              }).catch(() => {
              });
              this.props.closeModal();
            }
          }
        }}>
        {I10n.get('app.action.continue')}
      </Button>
    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          <HelpMeChooseWrapper><LicenceSelectorHMCToggle disabled={this.props.configurationSaver.isSaving || this.state.licencesLoading} onClick={() => {
            this.openHelpMeChooseModal();
          }}></LicenceSelectorHMCToggle></HelpMeChooseWrapper>
          {buttons}
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  // To be removed
  showNotification = (notificationText) => {
    this.updateStateIfMounted({showNotification: true, notificationText});
    setTimeout(() => { this.hideNotification(); }, 10000);
  }

  // To be removed
  hideNotification = () => {
    this.updateStateIfMounted({showNotification: false});
  }

  renderNotification = () => {
    return (
      <NotificationContainer>
        <NotificationWrapper>
          <CheckAndMessageWrapper>
            <CheckIconWrapper>
              <MsxIcons name="done-stroke"></MsxIcons>
            </CheckIconWrapper>
            {this.state.notificationText}
          </CheckAndMessageWrapper>
          <IconWrapper onClick={() => {
            this.hideNotification();
          }}>
            <MsxIcons name="close"></MsxIcons>
          </IconWrapper>
        </NotificationWrapper>
      </NotificationContainer>
    );
  }

  render = () => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.licence_selector.title')}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          applicationParameters={this.props.applicationParameters}
          steps={getSoftwareStepperLabels()}
          activeStep={softwareStepsConfig.licence_selector}
          stepperActions={this.getStepperActions(isSaved)}
          selectedCriteria={this.props.callByRangeReducer?.selectedItems || {}}
          clearCategory={this.clearCBRCategory}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          redirectWithCBR={false}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={true}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent())}
        {this.renderNavigationButtonSection()}
        {this.state.showNotification && this.renderNotification()}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {

  return {
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    addSoftwareLicences: (licencesWithQuantity, selectorOrigin) => dispatch(addSoftwareLicences(licencesWithQuantity, selectorOrigin)),
    removeSoftwareLicence: (licence) => dispatch(removeSoftwareLicence(licence)),
    setLicenseModel: (newLicenseModel) => dispatch(setLicenseModel(newLicenseModel)),
    setSoftwareLicenceQuantity: (licence, newQuantity) => dispatch(setSoftwareLicenceQuantity(licence, newQuantity)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    setCallByRangeSelectedItems: (items) => dispatch(setCBRSelectedItems(items)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    updateMsxSoftwareLicenseReferences: (config) => dispatch(updateMsxSoftwareLicenseReferences(config))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenceSelectorScreen);
